import { LicenseInfo } from "@mui/x-data-grid-pro";
import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { makeStyles } from "../makeStyles";
import { AppRoute } from "../Routes";
import SiteAppBar from "./SiteAppBar";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  header: {
    top: 0,
    zIndex: 1000,
    position: "sticky",
  },
  content: {
    flexGrow: 1,
  },
  paddedContent: {
    padding: theme.spacing(3),
  },
}));

const Layout: React.FunctionComponent<React.PropsWithChildren<{}>> = (props) => {
  const { classes, cx } = useStyles();

  useEffect(() => {
    if (import.meta.env.VITE_MUI_DATAGRID_PRO_LICENSE_KEY) {
      LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_DATAGRID_PRO_LICENSE_KEY);
    }
  }, []);

  const onPrScreen = useRouteMatch(AppRoute.PracticeReview);

  return (
    <div className={classes.root}>
      {onPrScreen ? null : (
        <div className={classes.header}>
          <SiteAppBar />
        </div>
      )}

      <main
        className={cx(classes.content, {
          [classes.paddedContent]: !onPrScreen,
        })}
      >
        {props.children}
      </main>
    </div>
  );
};

export default Layout;
